// extracted by mini-css-extract-plugin
module.exports = {"warper":"EditNameInput_warper_JbyQY","name":"EditNameInput_name_1Dlen","editIcon":"EditNameInput_editIcon_2FnQk","input":"EditNameInput_input_n_wZ9"};